import type { MenuItem } from "./Header.types";
import { ROUTES } from "@/config/constants";

export const MENU_ITEMS: MenuItem[] = [
  {
    icon: (
      <span className="material-symbols-outlined text-xl leading-none text-black">
        search
      </span>
    ),
    title: "Trade Lookup",
    subtitle: "Find and view trade details",
    path: ROUTES.TRADE_LOOKUP,
  },
  {
    icon: (
      <span className="material-symbols-outlined text-xl leading-none text-black">
        database
      </span>
    ),
    title: "Static Data",
    subtitle: "Manage trade processing data",
    path: ROUTES.STATIC_DATA_LOOKUP,
  },
  {
    icon: (
      <span className="material-symbols-outlined text-xl leading-none text-black">
        bar_chart
      </span>
    ),
    title: "Reports",
    subtitle: "Key trade processing metrics and reports",
    path: ROUTES.REPORTS,
  },
  {
    icon: (
      <span className="material-symbols-outlined text-xl leading-none text-black">
        info
      </span>
    ),
    title: "About Salerio",
    subtitle: "Product and company information",
    path: ROUTES.ABOUT,
  },
];
